import { Button, useModal } from '@billy/design-system'
import { ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { BlockCancelInvoiceActionVariant } from '@features/invoices/elements/BlockCancelInvoiceActionModal/enums/blockCancelInvoiceActionVariant'
import { getBlockCancelInvoiceActionModalId } from '@features/invoices/elements/BlockCancelInvoiceActionModal/utils/getBlockCancelInvoiceActionModalId'
import { getCancelDepositInvoiceEligibility } from '@features/invoices/utils/depositInvoices/getCancelDepositInvoiceEligibility'

import { useInvoice } from '../../../../contexts/invoiceContext'
import { useTrackInvoiceView } from '../../../../hooks/useTrackInvoiceView'
import { useCreateCreditNote } from '../../hooks/useCreateCreditNote'

export const CreateCreditNoteButton = (): ReactElement => {
  const { t } = useTranslation()
  const { invoice, invoiceId } = useInvoice()
  const { open: openBlockCancelInvoiceActionModal } = useModal(
    getBlockCancelInvoiceActionModalId(invoiceId, BlockCancelInvoiceActionVariant.CreditNote),
  )
  const { createCreditNote } = useCreateCreditNote()
  const { trackInvoiceView } = useTrackInvoiceView()

  const { isCancelBlockedByFinalInvoice } = getCancelDepositInvoiceEligibility(invoice)

  const handleCreateCreditNoteButtonClick = useCallback(() => {
    trackInvoiceView('Create credit note action clicked')

    if (isCancelBlockedByFinalInvoice) {
      openBlockCancelInvoiceActionModal()
      return
    }

    createCreditNote()
  }, [createCreditNote, isCancelBlockedByFinalInvoice, openBlockCancelInvoiceActionModal, trackInvoiceView])

  return (
    <Button color="danger" icon="fileXCorner" onClick={handleCreateCreditNoteButtonClick} variant="outlined">
      {t('invoices.side_actions.cancel_with_credit_note')}
    </Button>
  )
}
